import { v4 as uuidv4 } from 'uuid';
import { getBase64 } from './array';

export async function shapeFile(file) {
  const base64 = await getBase64(file);
  return {
    file,
    name: file.name,
    readableSize: file.size,
    preview: URL.createObjectURL(file),
    progress: 0,
    uploaded: false,
    error: false,
    url: null,
    base64,
    idFile: uuidv4(),
  };
}

export function customValidations(
  filesInput,
  maxSizeFiles,
  maxQuantityFiles = 1,
  validExtension = ['csv'],
  invalidCallback = () => null
) {
  const errors = {
    hasMaxSize: false,
    hasMaxQuantity: false,
    hasValidExtension: false,
  };

  const fileErrors = [];
  const filteredFiles = filesInput.filter((item) => {
    errors.hasMaxSize = false;
    errors.hasValidExtension = false;
    if (maxSizeFiles && item.readableSize > maxSizeFiles)
      errors.hasMaxSize = true;

    if (!validExtension.includes(item.name.split('.').pop().toLowerCase()))
      errors.hasValidExtension = true;

    if (filesInput.length > maxQuantityFiles) errors.hasMaxQuantity = true;
    if (
      !(item.readableSize > maxSizeFiles) &&
      validExtension.includes(item.name.split('.').pop().toLowerCase()) &&
      filesInput.length <= maxQuantityFiles
    ) {
      return item;
    }
    const { hasMaxQuantity, ...rest } = errors;
    fileErrors.push({ error: rest, item });
  });

  invalidCallback({ fileErrors, hasMaxQuantity: errors.hasMaxQuantity });

  return filteredFiles;
}
